<template>
  <!-- 半屏的供应商书名批量查询页面   class="container" -->
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-light">
          <span>供应商书名批量查询</span>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24" style="margin-top: -14px; margin-bottom: 6px;">
        <span style="color: red; font-size: 14px;">说明：</span>
        <span style="color: #67c23a; font-size: 14px;">
          <br>只能上传Excel文件，文件内容必须包含ISBN(或书名)和数量，可先下载样例文件再进行操作。
          <br>自己的库(供货商填写自己导入的供货商),系统库(供货商填写供货商代码或者找客服)。
          <br>导入数据量越大，请耐心等待。
        </span>
      </el-col>
      <el-col :span="4">
        <el-upload action="no" :limit="1"  :on-remove="changeFileLength" :on-change="changeFileLength"  class="upload-demo" ref="upload" :auto-upload="false" :http-request="uploadOk">
          <el-button :disabled="selectFileBtnFlag" size="small" icon="el-icon-upload2" type="primary">上传下单书目文件</el-button>
        </el-upload>
      </el-col>
      <el-col :span="8">
        <el-button size="small" icon="el-icon-share" @click="selectSupplierClickHander"
          type="warning">选择供货商( <b style="color: black;font-size: 12px;">{{ selectSupplierList.length }}</b> )</el-button>
        <el-button size="small" icon="el-icon-share" @click="selectPrioritySupplierClickHander" :disabled="selectPrioritySupplierDisabled"
          type="warning">优先供货商( <b style="color: black;font-size: 12px;">{{ selectPrioritySupplierList.length }}</b> )</el-button>
        <el-checkbox v-model="selectSystemFlag" @change="selectSystemChangeHander" style="margin-left: 16px;">系统库</el-checkbox>
      </el-col>
      <el-col :span="8">
        <el-input size="small" style="width:180px" v-model="productNumGe">
          <template slot="prepend">副本数量 >=</template>
        </el-input>
        <!-- <el-button :disabled="uploadFileBtnFlag" size="small" icon="el-icon-share" type="success" @click="matchProductISBN">ISBN匹配下单</el-button> -->
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <!-- <el-button :disabled="uploadFileBtnFlag" size="small" icon="el-icon-share" type="success" @click="matchProductISBN">ISBN匹配下单</el-button> -->
        <el-button :disabled="uploadFileBtnFlag" size="small" icon="el-icon-share" type="success" @click="matchProductName">书名匹配下单</el-button>
        <!-- <el-button size="small" icon="el-icon-download" plain type="success" @click="downloadModelISBN">ISBN下载样例文件</el-button> -->
        <el-button size="small" icon="el-icon-download" plain type="success" @click="downloadModelProName">书名下载样例文件</el-button>
      </el-col>
      <!-- <el-col :span="24" >
        <div v-for="(item, i) in batchMesageList" :key="i">
          <span style="color: red; font-size: 12px;" v-if="item && item.length > 0">
            {{ item }}
          </span>
        </div>
      </el-col> -->
      <el-col :span="24" >
        <div v-for="(item, i) in whBatchProductMsgList" :key="i">
          <span style="color: red; font-size: 12px;" v-if="item && item.msg">
            [{{ item.msgTime }}] {{ item.msg }}
          </span>
        </div>
      </el-col>
    </el-row>

    <el-card class="box-card">
      <div slot="header" class="clearfix" style="margin: -10px auto;">
        <span>匹配成功清单</span>
        <el-button v-if="tableData.length > 0" style="margin-left: 20px;" size="mini" icon="el-icon-download" type="success" @click="matchProductAllExport">导出全部匹配数据</el-button>
      </div>
      <div>
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
          :page-size="pagesize" layout="total,prev,pager,next" :total="pageTotal">
        </el-pagination>
      </div>
      <el-row>
        <el-col :span="24">
          <div>
            <el-table v-loading="loading" :data="tableData"  size="small" @selection-change="handleSelectionChange" element-loading-text="正在匹配商品中，请稍后。。。" ref="multipleTable" tooltip-effect="dark" style="width: 100%">
              <el-table-column type="selection" align="center" width="55" />
              <!-- <el-table-column label="供应商" width="120">
                <template slot-scope="scope">
                  {{ scope.row.warehouseCode ? scope.row.warehouseCode : scope.row.supWarehouseCode }}
                </template>
              </el-table-column>
               -->
              <el-table-column label="图书名称" align="center" prop="productName"/>
              <el-table-column align="center" label="ISBN" width="180" prop="productSn"/>
              <!-- 
                <el-table-column label="来源库" align="center" prop="discount" width="100">
                <template slot-scope="scope">
                  <div style="color:green;" v-if="scope.row.productSource === '0'">系统库</div>
                  <div style="color:saddlebrown;" v-else>供应商自己库</div>
                </template>
              </el-table-column>
             -->
              <el-table-column align="center" label="作者" width="180" prop="author"/>
              <el-table-column align="center" label="出版社" width="180" prop="providerName"/>
              <el-table-column align="center" label="出版时间" width="100" prop="providerTime"/>
              <!-- <el-table-column label="折扣价" prop="shopPrice" width="100" align="center">
                <template slot-scope="scope">
                  <div>￥{{ scope.row.shopPrice }}</div>
                </template>
              </el-table-column>
              <el-table-column label="折扣" align="center" prop="discount" width="90"/> -->
              <el-table-column label="定价" prop="marketPrice" width="100" align="center">
                <template slot-scope="scope">
                  <div>￥{{ scope.row.marketPrice }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="productNum" label="库存数量" width="100" align="center"/>
            </el-table>
            <!-- <div style="margin-top: 10px">
              <el-button type="primary" :disabled="selectSystemFlag" icon="el-icon-shopping-cart-2" style="width: 130px; float:right;" @click="addCart">加入购物车</el-button>
            </div> -->
          </div>
        </el-col>
      </el-row>
      <!-- <div class="page">
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
          layout="total,prev,pager,next" :total="pageTotal">
        </el-pagination>
      </div> -->
    </el-card>
    
    <el-dialog width="90%" :title="selectLabel === 1 ? '选择供货商':'优先供货商'" :visible.sync="dialogTableVisible">
      <el-form ref="form" label-width="100px" size="small">
        <el-row>
          <!-- 选择供货商 -->
          <el-col :span="24" v-show="selectLabel == 1">
            <el-checkbox-group v-model="selectSupplierList" @change="selectSupplierChangeHandler">
              <el-checkbox :label="item.id" v-for="(item, index) in dataSupplierList" :key="index">{{ item.supWarehouseName }}</el-checkbox>
            </el-checkbox-group>
          </el-col>
          <!-- 选择优先供货商 -->
          <el-col :span="24" v-show="selectLabel == 2">
            <el-checkbox-group v-model="selectPrioritySupplierList">
              <el-checkbox :label="item.id" v-for="(item, index) in dataPrioritySupplierList" :key="index">{{ item.supWarehouseName }}</el-checkbox>
            </el-checkbox-group>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" :disabled="confirmLoading" @click="onCommitSelect">确定</el-button> -->
        <el-button @click="selectAllWh(1)" v-if="selectAllFlag">全选</el-button>
        <el-button @click="selectAllWh(0)" v-else>全不选</el-button>
        <el-button @click="dialogTableVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { downFile, getAction, postAction } from "../../api/index";
import { mapGetters } from "vuex";
export default {
  name: "whBoProductname",
  data() {
    return {
      tableData: [], // 匹配成功的table
      tableData1: [], // 匹配失败的table
      errorAllList: [], // 所有匹配失败的数据
      searchWHList: [],
      matchingInfo: {}, // 匹配记录信息
      loading: false,
      selectProductList: [],
      fileList: [],
      fileName: "",
      uploadForm: {
        productNumGe: 0,
        fileList: [],
      },
      currentPage: 1, // 当前页码
      pagesize: 20, // 每页显示的行数
      pageTotal: 0,
      errPage:{
        currentPage: 1, // 当前页码
        pagesize: 10, // 每页显示的行数
        pageTotal: 0,
      },
      url: {
        matchWHProductISBNExecl: "/whBatchOrder/matchWHProductExecl",
        matchWHProductExeclByAync: "/whBatchOrder/matchWHProductExeclByAync",
        matchWHProductJson: "/whBatchOrder/matchWHProductJsonByAync",
        matchWHProductExport: "/whBatchOrder/matchWHProductExport",
        addWHCart: "/cart/wh/addcart",
        queryCartWHList: "/cart/wh/queryCartWHList",
        matchWHProductErrorDataPage: "/whBatchOrder/matchWHProductErrorDataPage", // 分页
        matchWHProductSuccessDataPage: "/whBatchOrder/matchWHProductSuccessDataPage", // 分页
        queryWHCustomerSupplierList: "/provider/queryWHCustomerSupplierList",// 供应商导入的供货商信息列表
      },
      searchType: 'productName', // “isbn”， “productName” "other"
      productNumGe: 0,
      batchNumber: '', // 批次号
      filesLength: 0, // 文件长度
      BSfileList: [], // 选择文件集合
      selectFileBtnFlag: false,
      uploadFileBtnFlag: true,
    
      confirmLoading: false,
      dialogTableVisible: false, // dialog
      selectSystemFlag: false, // 选择系统库
      selectLabel: 1, // 1：选择供货商，2：选择优先供货商
      selectPrioritySupplierDisabled: true, // 选择优先供货商禁用
      selectSupplierList: [],  // 选择供货商列表(选中的值)
      selectPrioritySupplierList: [],  // 选择优先供货商列表 (选中的值)
      dataSupplierList: [],  // 选择供货商列表(要选择的数据)
      dataPrioritySupplierList: [],  // 选择优先供货商列表(要选择的数据)
      selectAllFlag: true,
      selectAll1Flag: true,
      selectAll2Flag: true,
      batchMesageList: [],
      timerObj: null,
    };
  },
  components: {},
  computed: {
    ...mapGetters(["isNaName"]),
    whBatchProductMsgList() {
      return this.$store.state.socket.whBatchProductMsgList
    },
    whBatchProdectNameEnd() {
      return this.$store.state.socket.whBatchProdectNameEnd
    },
  },
  watch: {
    whBatchProductMsgList: {
      handler(newValue) {
        // console.log("whBatchProductMsgList", newValue)
        if(newValue){
          // this.handlerSocketMessage()
        }
      },
      immediate: true,
      deep: true,
    },
    whBatchProdectNameEnd: {
      handler(newValue) {
        // console.log("whBatchProdectNameEnd", newValue)
        if(newValue){
          this.getBatchOrder()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.getBatchOrder()
  },
  methods: {
    selectAllWh(a){
      const that = this
      if(that.selectLabel == 1){ // 选择供货商
        if(a == 1){
          var arr1=[]
          if(that.dataSupplierList && that.dataSupplierList.length > 0){
            that.dataSupplierList.forEach(element => {
              arr1.push(element.id)
            });
          }
          that.selectSupplierList = arr1
        } else if(a == 0) {
          that.selectSupplierList = []
          that.selectPrioritySupplierList = []
        }
        that.selectSupplierChangeHandler(that.selectSupplierList)
        that.selectAll1Flag = !that.selectAll1Flag
      } else if(that.selectLabel == 2){ // 选择优先供货商
        if(a == 1){
          var arr=[]
          if(that.dataPrioritySupplierList && that.dataPrioritySupplierList.length > 0){
            that.dataPrioritySupplierList.forEach(element => {
              arr.push(element.id)
            });
          }
          that.selectPrioritySupplierList = arr
        } else if(a == 0) {
          that.selectPrioritySupplierList = []
        }
        that.selectAll2Flag = !that.selectAll2Flag
      }
      that.selectAllFlag = !that.selectAllFlag
    },
    selectSupplierClickHander(){ // 选择供货商
      this.selectLabel = 1
      this.dialogTableVisible = true
      this.selectAllFlag = this.selectAll1Flag
      this.getDataSupplierList()
    },
    selectSupplierChangeHandler(e){
      if(e && e.length > 0){
        this.selectPrioritySupplierDisabled = false
        this.selectSystemFlag = false
        //
        for(var i=this.selectPrioritySupplierList.length-1; i>=0;i--){
          if(e.indexOf(this.selectPrioritySupplierList[i]) <=-1){
            this.selectPrioritySupplierList.splice(i, 1); 
          }
        }
      } else {
        this.selectPrioritySupplierDisabled = true
      }
    },
    selectPrioritySupplierClickHander(){ // 选择优先供货商
      const that = this
      this.selectLabel = 2
      this.dialogTableVisible = true
      this.selectAllFlag = this.selectAll2Flag
      var arr=[]
      if(that.selectSupplierList && that.selectSupplierList.length > 0){
        that.dataSupplierList.forEach(element => {
          if(that.selectSupplierList.indexOf(element.id) > -1){
            arr.push(element)
          }
        });
      }
      this.dataPrioritySupplierList = arr
    },
    selectSystemChangeHander(e){ // 选择系统库
      this.dialogTableVisible = false
      if(e){
        this.selectPrioritySupplierDisabled = true
        this.dataPrioritySupplierList = []
        this.selectSupplierList = []
        this.selectPrioritySupplierList = []
        this.selectAllFlag = true
        this.selectAll1Flag = true
        this.selectAll2Flag = true
      }
    },
    // onCommitSelect(){
    //   this.dialogTableVisible = false
    //   // if(this.selectLabel === 1) {
    //     if(this.selectSupplierList && this.selectSupplierList.length > 0){
    //       this.selectPrioritySupplierDisabled = false
    //     }
    //   // }
    // },

    // 选择文件，修改当前文件列表长度后
    changeFileLength(singleFile, fileList){
      // console.log('修改当前文件', singleFile, fileList)
      this.filesLength = fileList.length
      this.BSfileList = fileList
      if(fileList.length > 0){
        this.uploadFileBtnFlag = false
      }else{
        this.uploadFileBtnFlag = true
      }
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    uploadOk(val) { // 调用上传接口
      // console.log("uploadOk===",val);
      const that = this
      if(!that.selectSystemFlag && that.selectSupplierList.length <= 0){
        that.$message.error("请选择供货商或者系统库！");
        return false;
      }
      that.setTimer(0);
      that.loading = true;
      that.errPage.pageTotal = 0
      that.pageTotal = 0
      that.tableData = []
      that.tableData1 = []
      that.searchWHList = []
      that.uploadFileBtnFlag = true
      that.selectFileBtnFlag = true
      let fd = new FormData();
      fd.append("searchType", that.searchType);
      fd.append("productNumGe", that.productNumGe);
      fd.append("warehouseUserId", that.$store.state.userInfo.id);
      fd.append("productSource", that.selectSystemFlag ? '0' : '1');
      if(!that.selectSystemFlag){
        fd.append("selectSuppliers", that.selectSupplierList.join(","));
        fd.append("prioritySuppliers", that.selectPrioritySupplierList.join(","));
      }
      fd.append("file", val.file);
      that.currentPage = 1
      // var url = that.url.matchWHProductISBNExecl + "?pageNo="+that.currentPage+"&pageSize="+that.pagesize
      // postAction(url, fd).then((res) => {
      //   // console.log("uploadOk-res :>> ", res);
      //   that.handleUploadSuccess(res, 0)
      // });
      var url = that.url.matchWHProductExeclByAync
        postAction(url, fd).then((res) => {
          // console.log("uploadOk-res :>> ", res);
          that.handleUploadSuccess(res, 0)
        });
    },
    handleUploadSuccess(res, a) {
      const that = this
      console.log("handleUploadSuccess-res :>> ", a, res);
      that.filesLength = 0
      that.BSfileList = []
      that.uploadFileBtnFlag = true
      that.selectFileBtnFlag = false
      that.batchMesageList = []
      if (res.data.success) {
        that.setBatchMessage(res.data.message, 0)
        that.$message.success(res.data.message);
        that.matchingInfo = res.data.resultOther.matchingInfo
        that.batchNumber = res.data.resultOther.batchNumber
        // // 失败的信息
        // that.errorAllList = res.data.resultOther.error;
        // // 失败的信息分页
        // that.tableData1 = res.data.resultOther.errorPageRecords;
        // that.errPage.pageTotal = res.data.resultOther.errorPageTotal;
        
        // that.pageTotal = res.data.result ? res.data.result.total : 0;
        // if(a == 1){
        //   // 累加数组
        //   that.tableData = that.tableData.concat(res.data.result.records)
        // } else {
        //   // 覆盖数组
        //   that.tableData = res.data.result ? res.data.result.records: [];
        //   if(res.data.resultOther.searchWHExeclList && res.data.resultOther.searchWHExeclList.length > 0){
        //     that.searchWHList = res.data.resultOther.searchWHExeclList;
        //   }
        // }
        // 获取信息 开启定时器
        that.setTimer(1);
      } else {
        that.$message.warning("暂未匹配到您所要找的图书！");
      }
      that.loading = false;
      that.$refs.upload.clearFiles();
    },
    matchProductISBN() {
      // console.log("matchProduct===");
      this.$store.commit("hasLogin");
      if (this.isNaName) {
        this.tologin1();
      }
      this.searchType = 'isbn'
      this.$refs.upload.submit();
    },
    matchProductName() {
      // console.log("matchProduct===");
      this.$store.commit("hasLogin");
      if (this.isNaName) {
        this.tologin1();
      }
      this.searchType = 'productName'
      this.$refs.upload.submit();
    },
    setTimer(a){
      console.log('111111111111111', a);
      // const that = this
      // clearInterval(that.timerObj)
      // if(a === 1){
      //   that.setBatchMessage("系统正在匹配...", 1)
      //   that.getBatchOrder()
      //   that.timerObj = setInterval(function(){
      //     that.getBatchOrder()
      //   }, 1000 * 10); // 10秒钟一次
      // }
    },
    getBatchOrder(){
      // this.handleCurrentErrorChange(this.errPage.currentPage);
      this.handleCurrentChange(this.currentPage);
    },
    matchProductISBNTwo() {
      this.searchType = 'isbn'
      this.matchProductTwo()
    },
    matchProductProductNameTwo() {
      this.searchType = 'productName' 
      this.matchProductTwo()
    },
    matchProductTwo() {
      // console.log("matchProduct===");
      const that = this
      that.$store.commit("hasLogin");
      if (that.isNaName) {
        that.tologin1();
        return false;
      }
      if(!that.selectSystemFlag && that.selectSupplierList.length <= 0){
        that.$message.error("请选择供货商或者系统库！");
        return false;
      }
      that.loading = true
      
      that.errPage.currentPage = 1
      that.errPage.pageTotal = 0
      
      that.currentPage = 1
      that.pageTotal = 0

      that.tableData = []
      that.tableData1 = []
      var url = that.url.matchWHProductJson
      postAction(url, {
        warehouseUserId: that.$store.state.userInfo.id,
        productSource: that.selectSystemFlag ? '0' : '1',
        selectSuppliers: that.selectSupplierList.join(","),
        prioritySuppliers: that.selectPrioritySupplierList.join(","),
        productNumGe: that.productNumGe,
        searchType: that.searchType,
        batchNumber: that.batchNumber,
        searchJsonArrayData: JSON.stringify(that.searchWHList),
      }).then((res) => {
        // console.log("matchProductTwo-res :>> ", res);
        that.handleUploadSuccess(res, 0)
      });
    },
    matchProductAllExport(){
      const that = this
      let fileName = this.$store.state.userInfo.warehouseName + '-批量查询-';
      downFile(that.url.matchWHProductExport, {
        warehouseUserId: that.$store.state.userInfo.id,
        productNumGe: that.productNumGe,
        batchNumber: that.batchNumber,
        matchingId: that.matchingInfo ? that.matchingInfo.id : '',
        searchType: that.searchType,
        productSource: that.selectSystemFlag ? '0' : '1',
        // searchJsonArrayData: JSON.stringify(that.searchWHList),
      }).then((data) => {
        that.loading = false;
        console.log("data :>> ", data);
        if(data && data.data && data.data.size > 0){
          that.$message.success('查找数据完成，导出文件...')
          let url = window.URL.createObjectURL(new Blob([data.data]))
          // console.log("url :>> ", data.headers['content-type']);
          let a = document.createElement('a')
          let nowD = new Date()

          let contentType = data.headers['content-type'];
          let ext = "xlsx";
          if (contentType.indexOf("application/zip") > -1) {
            ext = "zip";
          }
          // a.setAttribute('download', fileName + nowD.getFullYear() + '-' + (nowD.getMonth() + 1) + '-' + nowD.getDate() + '.zip')
          a.setAttribute('download', fileName + nowD.getFullYear() + '-' + (nowD.getMonth() + 1) + '-' + nowD.getDate() + '.' + ext)
          a.href = url
          a.click()
        } else {
          that.$message.warning('数据文件失效，导出失败，请重新匹配后再导出...')
        }
      });
    },
    handleCurrentErrorChange(val) { // 分页切换
      console.log("val------ :>> ", val);
      const that = this
      that.$store.commit("hasLogin");
      if (that.isNaName) {
        that.tologin1();
        return false
      }
      this.errPage.currentPage = val;
      var url = that.url.matchWHProductErrorDataPage + "?pageNo="+that.errPage.currentPage+"&pageSize="+that.errPage.pagesize
      postAction(url, {
        warehouseUserId: that.$store.state.userInfo.id,
        opeartionUid: that.$store.state.userInfo.id,
        batchNumber: that.batchNumber,
        searchType: that.searchType,
      }).then((res) => {
        // console.log("handleCurrentErrorChange-res :>> ", res);
        that.errPage.pageTotal = res.data.result ? res.data.result.total : 0;
        // 覆盖数组
        that.tableData1 = res.data.result.records;
        if(that.tableData1 && that.tableData1.length > 0){
          that.setTimer(0);
        }
        that.setBatchMessage("匹配失败 " + that.errPage.pageTotal +" 条", 2)
        that.searchType = res.data.resultOther.searchType
        if(res.data.resultOther.searchWHExeclList && res.data.resultOther.searchWHExeclList.length > 0){
          that.searchWHList = res.data.resultOther.searchWHExeclList;
        }
      });
    },
    handleCurrentChange(val) { // 分页切换
      console.log("val------ :>> ", val);
      // console.log("matchProduct===");
      const that = this
      that.$store.commit("hasLogin");
      if (that.isNaName) {
        that.tologin1();
        return false
      }
      that.loading = true;
      this.currentPage = val;
      var url = that.url.matchWHProductSuccessDataPage + "?pageNo="+that.currentPage+"&pageSize="+that.pagesize
      postAction(url, {
        warehouseUserId: that.$store.state.userInfo.id,
        opeartionUid: that.$store.state.userInfo.id,
        productNumGe: that.productNumGe,
        batchNumber: that.batchNumber,
        searchType: that.searchType,
        productSource: that.selectSystemFlag ? '0' : '1',
        selectSuppliers: that.selectSupplierList.join(","),
        prioritySuppliers: that.selectPrioritySupplierList.join(","),
        searchJsonArrayData: JSON.stringify(that.searchWHList),
      }).then((res) => {
        that.loading = false;
        // console.log("handleCurrentChange-res :>> ", res);
        that.pageTotal = res.data.result ? res.data.result.total : 0;
        // 覆盖数组
        that.tableData = res.data.result.records;
        if(that.tableData && that.tableData.length > 0){
          that.setTimer(0);
        }
        that.setBatchMessage("匹配成功 " + that.pageTotal +" 条", 3)
        that.searchType = res.data.resultOther.searchType
        if(res.data.resultOther.searchWHExeclList && res.data.resultOther.searchWHExeclList.length > 0){
          that.searchWHList = res.data.resultOther.searchWHExeclList;
        }
      });
    },
    handleSelectionChange(val) {
      this.selectProductList = val;
    },
    //加入购物车
    addCart() {
      const that = this;
      that.$store.commit("hasLogin");
      if (that.isNaName) {
        that.tologin1();
      }
      if(that.selectProductList.length == 0){
        that.$message({message: "未选择图书！", type: "warning",});
        return;
      }
      let storeCartWHList = that.$store.state.shopWHCart
        // console.log('addCart', rowList)
        // console.log('listCart', storeCartWHList)

      let params = [];
      for (let i = 0; i < that.selectProductList.length; i++) {
        var sp = that.selectProductList[i]
        // 校验库存是否已超过真实库存。
        if (storeCartWHList && storeCartWHList.length > 0) {
          for (let j = 0; j < storeCartWHList.length; j++) {
            let cartObj = storeCartWHList[j]
            if(cartObj 
              && cartObj.productStockId === sp.id
              && (cartObj.productNumber + sp.buyNum) > sp.productNum
            ){
              that.$message.error(sp.productName + " 加购的图书数量(包括购物车中的)大于当前库存");
              return false
            }
          }
        }
        let proParams = {};
        proParams.productStockId =  that.selectProductList[i].id
        proParams.productSource = that.selectProductList[i].productSource
        proParams.productNumber = that.selectProductList[i].buyNum
        params.push(proParams);
      }
      // console.log('1111111', params)
      let user_id = that.$store.state.userInfo.id;
      postAction(that.url.addWHCart, {
        params: JSON.stringify(params),
        whUId: user_id,
      }).then((res) => {
        if (res.data.success) {
          that.getCartItems();
          that.$message({message: "加入购物车成功！",type: "success",});
        }
      });
    },
    getCartItems() {
      //获取购物车信息,并存入vuex
      getAction(this.url.queryCartWHList, {
        whUId: this.$store.state.userInfo.id,
      }).then((ret) => {
        if (ret.data.success) {
          this.$store.state.shopWHCart = ret.data.result;
          window.sessionStorage.setItem("shopWHCart",JSON.stringify(ret.data.result));
        }
      });
    },
    getDataSupplierList(){ // 供应商导入的供货商信息列表
      getAction(this.url.queryWHCustomerSupplierList, {
        whUId: this.$store.state.userInfo.id,
      }).then((ret) => {
        if (ret.data.success) {
          this.dataSupplierList = ret.data.result
        }
      });
    },
    setBatchMessage(msg, a){
      console
      const that = this
      if(a == 0){
        that.batchMesageList = []
      }
      if(a == 2 || a == 3){
        if(that.tableData.length == 0 && that.tableData1.length == 0){
          return false;
        }
      }
      that.batchMesageList[a] = msg
    },
    downloadModelISBN() {
      window.open(this.staticDomainURL+"/batchOrder/批量查单模板-ISBN.xls");//TODO 下载的方法
    },
    downloadModelProName() {
      window.open(this.staticDomainURL+"/batchOrder/批量查单模板-书名.xls");//TODO 下载的方法
    },
    tologin1() {
      this.$message({
        message: "请登录供应商身份账号！",
        type: "warning",
      });
      this.$router.push("/loginProvider");
    },
  },
};
</script>
<style lang="scss" scoped>
.clearfix {
  h1 {
    font-size: 18px;
    color: #333;
  }
  span{
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
}

.el-progress {
  width: 50%;
  line-height: 3;
  margin-left: 15px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple-light {
  line-height: 36px;
}
</style>
